import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserAuthEmptyState } from './AuthState';

const initialState: TokenState = UserAuthEmptyState;

export const authSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    updateToken: (state, action: PayloadAction<TokenState>) => {
      return action.payload;
    },
    updateJWTToken: (state, action: PayloadAction<string>) => {
      state.jwToken = action.payload;
    },
  },
});

export const { updateToken, updateJWTToken } = authSlice.actions;

export default authSlice.reducer;
